var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)",
    fill: "#A2A5B9"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 7,
    width: 16,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000) ",
    x: 0,
    y: 7,
    width: 16,
    height: 2,
    rx: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.19e4a5e844fb3c9eaf8bea31404fddad.svg";
export { ForwardRef as ReactComponent };